import { c as _c } from "react/compiler-runtime";
import { isPhoneNumber } from '@onefootprint/core';
import { Button, Form, InlineAlert } from '@onefootprint/ui';
import type { ElementType } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CardHeading from '../card-heading';
import PhoneField from './phone-field';
import type { DemoRequest } from './use-request-demo';
type DemoFormProps = {
  isPending?: boolean;
  failed?: boolean;
  onSubmit: (request: DemoRequest) => void;
  Title?: ElementType;
  Description?: ElementType;
};
const DemoForm = t0 => {
  const $ = _c(118);
  const {
    isPending: t1,
    failed: t2,
    onSubmit,
    Title,
    Description
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const failed = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      keyPrefix: "demo"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t3);
  const methods = useForm();
  let t4;
  if ($[1] !== t) {
    t4 = t(_temp);
    $[1] = t;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = <p className="fp-auth-overline mb-6 text-accent">{t4}</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t(_temp2);
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t(_temp3);
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== Description || $[10] !== Title || $[11] !== t6 || $[12] !== t7) {
    t8 = <CardHeading Title={Title} Description={Description} title={t6} description={t7} />;
    $[9] = Description;
    $[10] = Title;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <div className="pr-10">{t5}{t8}</div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== methods || $[18] !== onSubmit) {
    t10 = methods.handleSubmit(onSubmit);
    $[17] = methods;
    $[18] = onSubmit;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t(_temp4);
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t(_temp5);
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = {
      required: t12
    };
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t13) {
    t14 = <Form.Input name="firstName" label={t11} autoComplete="given-name" rules={t13} />;
    $[26] = t11;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp6);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t(_temp7);
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = {
      required: t16
    };
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17) {
    t18 = <Form.Input name="lastName" label={t15} autoComplete="family-name" rules={t17} />;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t(_temp8);
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t(_temp9);
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t20) {
    t21 = {
      required: t20
    };
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t19 || $[45] !== t21) {
    t22 = <Form.Input name="companyName" label={t19} autoComplete="organization" rules={t21} />;
    $[44] = t19;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t) {
    t23 = t(_temp10);
    $[47] = t;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t) {
    t24 = t(_temp11);
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t24) {
    t25 = {
      required: t24
    };
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t23 || $[54] !== t25) {
    t26 = <Form.Email name="email" label={t23} rules={t25} />;
    $[53] = t23;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t) {
    t27 = t(_temp12);
    $[56] = t;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t) {
    t28 = t(_temp13);
    $[58] = t;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t28) {
    t29 = {
      required: t28
    };
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t27 || $[63] !== t29) {
    t30 = <Form.Input name="jobTitle" label={t27} autoComplete="organization-title" rules={t29} />;
    $[62] = t27;
    $[63] = t29;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  let t32;
  if ($[65] !== t) {
    t31 = {
      validate: value => !value || isPhoneNumber(value) || t(_temp14)
    };
    t32 = t33 => {
      const {
        field: t34,
        fieldState: t35
      } = t33;
      const {
        onChange,
        onBlur,
        name
      } = t34;
      const {
        error
      } = t35;
      return <PhoneField name={name} label={t(_temp15)} onChange={onChange} onBlur={onBlur} error={error?.message} />;
    };
    $[65] = t;
    $[66] = t31;
    $[67] = t32;
  } else {
    t31 = $[66];
    t32 = $[67];
  }
  let t33;
  if ($[68] !== methods.control || $[69] !== t31 || $[70] !== t32) {
    t33 = <Controller control={methods.control} name="phoneNumber" rules={t31} render={t32} />;
    $[68] = methods.control;
    $[69] = t31;
    $[70] = t32;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== t14 || $[73] !== t18 || $[74] !== t22 || $[75] !== t26 || $[76] !== t30 || $[77] !== t33) {
    t34 = <div className="grid gap-4 sm:grid-cols-2">{t14}{t18}{t22}{t26}{t30}{t33}</div>;
    $[72] = t14;
    $[73] = t18;
    $[74] = t22;
    $[75] = t26;
    $[76] = t30;
    $[77] = t33;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== t) {
    t35 = t(_temp16);
    $[79] = t;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  let t36;
  if ($[81] !== t) {
    t36 = t(_temp17);
    $[81] = t;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== t36) {
    t37 = {
      required: t36
    };
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] !== t35 || $[86] !== t37) {
    t38 = <Form.Textarea name="message" label={t35} rules={t37} />;
    $[85] = t35;
    $[86] = t37;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== failed || $[89] !== t) {
    t39 = failed ? <InlineAlert variant="error">{t(_temp18)}</InlineAlert> : null;
    $[88] = failed;
    $[89] = t;
    $[90] = t39;
  } else {
    t39 = $[90];
  }
  let t40;
  if ($[91] !== t) {
    t40 = t(_temp19);
    $[91] = t;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== t) {
    t41 = t(_temp20);
    $[93] = t;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== isPending || $[96] !== t40 || $[97] !== t41) {
    t42 = <Button className="fp-auth-cta self-start" size="large" type="submit" loading={isPending} disabled={isPending} loadingAriaLabel={t40}>{t41}</Button>;
    $[95] = isPending;
    $[96] = t40;
    $[97] = t41;
    $[98] = t42;
  } else {
    t42 = $[98];
  }
  let t43;
  if ($[99] !== t) {
    t43 = t(_temp21);
    $[99] = t;
    $[100] = t43;
  } else {
    t43 = $[100];
  }
  let t44;
  if ($[101] !== t43) {
    t44 = <p className="text-caption-2 text-tertiary">{t43}</p>;
    $[101] = t43;
    $[102] = t44;
  } else {
    t44 = $[102];
  }
  let t45;
  if ($[103] !== t39 || $[104] !== t42 || $[105] !== t44) {
    t45 = <div className="mt-2 flex flex-col gap-4">{t39}{t42}{t44}</div>;
    $[103] = t39;
    $[104] = t42;
    $[105] = t44;
    $[106] = t45;
  } else {
    t45 = $[106];
  }
  let t46;
  if ($[107] !== t10 || $[108] !== t34 || $[109] !== t38 || $[110] !== t45) {
    t46 = <form className="mt-6 flex flex-col gap-4" onSubmit={t10}>{t34}{t38}{t45}</form>;
    $[107] = t10;
    $[108] = t34;
    $[109] = t38;
    $[110] = t45;
    $[111] = t46;
  } else {
    t46 = $[111];
  }
  let t47;
  if ($[112] !== methods || $[113] !== t46) {
    t47 = <FormProvider {...methods}>{t46}</FormProvider>;
    $[112] = methods;
    $[113] = t46;
    $[114] = t47;
  } else {
    t47 = $[114];
  }
  let t48;
  if ($[115] !== t47 || $[116] !== t9) {
    t48 = <>{t9}{t47}</>;
    $[115] = t47;
    $[116] = t9;
    $[117] = t48;
  } else {
    t48 = $[117];
  }
  return t48;
};
export default DemoForm;
function _temp($) {
  return $.overline;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.description;
}
function _temp4($_2) {
  return $_2.form.firstName.label;
}
function _temp5($_3) {
  return $_3.form.firstName.error;
}
function _temp6($_4) {
  return $_4.form.lastName.label;
}
function _temp7($_5) {
  return $_5.form.lastName.error;
}
function _temp8($_6) {
  return $_6.form.companyName.label;
}
function _temp9($_7) {
  return $_7.form.companyName.error;
}
function _temp10($_8) {
  return $_8.form.email.label;
}
function _temp11($_9) {
  return $_9.form.email.error;
}
function _temp12($_10) {
  return $_10.form.jobTitle.label;
}
function _temp13($_11) {
  return $_11.form.jobTitle.error;
}
function _temp14($_12) {
  return $_12.form.phoneNumber.invalid;
}
function _temp15($_13) {
  return $_13.form.phoneNumber.label;
}
function _temp16($_14) {
  return $_14.form.message.label;
}
function _temp17($_15) {
  return $_15.form.message.error;
}
function _temp18($_16) {
  return $_16.form.error;
}
function _temp19($_17) {
  return $_17.form.submitting;
}
function _temp20($_18) {
  return $_18.form.cta;
}
function _temp21($_19) {
  return $_19.form.footnote;
}